// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap-1G1TQupX clearfix"};